let selectedExcessPaymentInputs = [
    {
        id: 'snapshot',
        label: 'Snapshot',
        type: 'textarea',
        placeholder: 'Snapshot',
        dataPath: 'excessValuesSnapshot'
    },
    {
        id: 'log',
        label: 'Log',
        type: 'textarea',
        placeholder: 'Log',
        dataPath: 'log'
    }
]

export { selectedExcessPaymentInputs }